<template>
    <div class="">
        <input type="hidden" name="config" :value="JSON.stringify(config)">

        <timing-period-module :dto="config.timing" :options="options" :compare="true"></timing-period-module>

        <div class="card shadow mb-3">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Optionen</h6>
            </div>
            <div class="card-body">

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['calculation.columns']"></i>
                        Anzuzeigende Spalten
                    </legend>

                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label><b>BGA</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-name"
                                           v-model="config.bgaNameCity">
                                    <label class="form-check-label" for="bga-name">
                                        Name und Ort
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-dates"
                                           v-model="config.bgaDates">
                                    <label class="form-check-label" for="bga-dates">
                                        Start- und Enddatum
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">Sell-Out</legend>

                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>
                                    <i class="fas fa-info-circle text-muted"
                                       style=""
                                       data-toggle="tooltip"
                                       data-placement="top"
                                       :title="$info['verkauf.leftBase']"></i>
                                    <b>Referenzpreis</b>
                                </label>
                                <select class="form-control" v-model="config.sellOutLeftBase">
                                    <option value="listenVk">Listen VK</option>
                                    <option value="kalkulierterVk">Kalkulierter VK</option>
                                    <option value="tatsaechlicherVk">Tatsächlicher VK</option>
                                </select>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label>
                                    <i class="fas fa-info-circle text-muted"
                                       style=""
                                       data-toggle="tooltip"
                                       data-placement="top"
                                       :title="$info['verkauf.rightBase']"></i>
                                    <b>Vergleichspreis</b>
                                </label>
                                <select class="form-control" v-model="config.sellOutRightBase">
                                    <option value="listenVk">Listen VK</option>
                                    <option value="kalkulierterVk">Kalkulierter VK</option>
                                    <option value="tatsaechlicherVk">Tatsächlicher VK</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['verkauf.compare']"></i>
                            <b>Bedingung</b>
                        </label>
                        <select class="form-control" v-model="config.compareOperator">
                            <option value="none">Keine</option>
                            <option value="equal">Vergleichspreis = (Gleich) Referenzpreis</option>
                            <option value="lower">Vergleichspreis &lt; (Kleiner) Referenzpreis</option>
                            <option value="greater">Vergleichspreis &gt; (Größer) Referenzpreis</option>
                        </select>
                    </div>

                    <div v-if="!['none', 'equal'].includes(config.compareOperator)">
                        <div class="form-group">
                            <label><b>Vergleich</b></label>
                            <select class="form-control" v-model="config.compareMode">
                                <option value="relative">Relativ (Prozent)</option>
                                <option value="absolute">Absolut (Euro)</option>
                            </select>
                        </div>

                        <div class="row mb-3">
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Min. Abweichung {{ limitUnit }}</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="0"
                                           v-model="config.lowerLimit">
                                </div>
                            </div>
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Max. Abweichung {{ limitUnit }}</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="50"
                                           v-model="config.upperLimit">
                                </div>
                            </div>
                        </div>
                    </div>

                </fieldset>

            </div>
        </div>

        <filtering-module :dto="config.filtering"
                          :options="options"
                          :warengruppen="true"
                          :dar="true"
                          :menge="true"
                          :wirkstoffe="true"
                          :reimport="true"></filtering-module>

        <pre v-if="$debugEnabled">{{ JSON.stringify(config, 0, 2) }}</pre>
    </div>
</template>

<script>

import TimingPeriodModule from "../Modules/TimingPeriodModule";
import FilteringModule from "../Modules/FilteringModule";

export default {
    components: {FilteringModule, TimingPeriodModule},
    props: {
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            config: this.dto,
        };
    },
    methods: {},
    computed: {
        limitUnit() {
            if (this.config.compareMode === 'relative') {
                return '%';
            }
            if (this.config.compareMode === 'absolute') {
                return '€';
            }

            return '?';
        },
    }
}
</script>
